/* eslint 'jsx-a11y/anchor-is-valid': 'off', eqeqeq: 'off', no-unused-vars: 'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup, Table } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { GetBuildingsList,GetBuildingsDetailsList, SaveHoliday } from '../../../../../../action/HolidaysAction';
import 'react-table/react-table.css';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';
import SearchInput, { createFilter } from 'react-search-input';
import Flatpickr from 'react-flatpickr';
import Conversions from '../../../../../../Resources/Conversions';

let IsModalClose = false;
const KEYS_TO_FILTERS = ['siteName', 'addrCity', 'addrStateProvince'];


class AddHolidayForm extends Component {

    componentWillMount() {
        this.props.GetBuildingsList();
    }
    constructor(props) {
        super(props);
        this.state = {
            Holiday_Name:'',
            Holiday_Date :new Date(),
            FormDisplay: true,
            error:false ,
            buildingerror: false,
            SelectedBuildings: [],
            rowsCount: 1,
            searchTerm: ''
        };
      this.nextForm = this.nextForm.bind(this);
      this.closePopup = this.closePopup.bind(this);
      this.CloseModal = this.CloseModal.bind(this);
      this.HolidaySave = this.HolidaySave.bind(this);
      this.BuildingSave = this.BuildingSave.bind(this);
      this.searchUpdated = this.searchUpdated.bind(this);
      this.handleChange = this.handleChange.bind(this);
    }

    CloseModal()  {
        this.props.closeModalPopUp("close");
    }
    nextForm() {
        this.setState({
            Holiday_Name : this.refs.New_Holiday_Name.value,
            Holiday_Date :this.state.Holiday_Date,
            FormDisplay: false,
            SelectedBuildings: []
            }, () => {
            this.props.GetBuildingsDetailsList();
        });

    }

    handleChange(date) {
        this.setState({
            Holiday_Date: new Date(date)
        });
    }



    BuildingSave(Rows){
        var lstbuilding = [];
        for(let i=0; i < Rows.length; i++){
            var id = Rows[i].props.children[0].props.children.ref;
            if(this.refs[id].checked){
                lstbuilding.push({siteID:this.refs[id].value,siteName:Rows[i].props.children[1].props.children[0],addrCity:Rows[i].props.children[2].props.children,addrStateProvince:Rows[i].props.children[3].props.children})
            }
        }
        if(lstbuilding.length > 0){
            this.setState({ SelectedBuildings: lstbuilding });
            this.closePopup();
        }else{
            this.setState({ buildingerror: true });
        }
    }


    closePopup(){
        this.setState({
            FormDisplay: true,
            searchTerm:''
        });
    }
    HolidaySave(){
        this.setState({
            error: false
        });
        IsModalClose = false;
        var IsValidHoliday = true;
        var New_Holiday_Name = this.refs.New_Holiday_Name.value;

        let twoDigitMonth = (this.state.Holiday_Date.getMonth() + 1).toString().length > 1 ? (this.state.Holiday_Date.getMonth() + 1) : "0" + (this.state.Holiday_Date.getMonth() + 1).toString();
        let twoDigitDay = this.state.Holiday_Date.getDate().toString().length > 1 ? this.state.Holiday_Date.getDate() : "0" + this.state.Holiday_Date.getDate().toString();

        var New_Holiday_Date = twoDigitMonth + "/" + twoDigitDay + "/" + this.state.Holiday_Date.getFullYear();

       // var New_Holiday_Date = new Date(this.state.Holiday_Date).toLocaleDateString();
        var Building_IDs = [];
        var Building_Names = [];

        //Past Date Validation
        if(New_Holiday_Date != null){
            var l_date = new Date();
            l_date.setHours(0,0,0,0);//discard the time
            var SpecialTo = new Date(New_Holiday_Date).setHours(0,0,0,0);
            if(Number(SpecialTo) < Number(l_date) ){
                IsValidHoliday = false;
                this.setState({
                    Holiday_Date: ""
                });
            }
        }

       if(New_Holiday_Name == null || New_Holiday_Name ==""){
            IsValidHoliday = false;

       }
       else if(New_Holiday_Date == null || New_Holiday_Date == ""){
            IsValidHoliday = false;

       }
       else if(this.state.SelectedBuildings == null || this.state.SelectedBuildings == ""){
            IsValidHoliday = false;
       }

       if(IsValidHoliday){
            this.state.SelectedBuildings.map(el => (( Building_IDs.push(el.siteID),Building_Names.push(el.siteName) )) );
            var editData = {
                "HolidayId": -1,
                "HolidayName": New_Holiday_Name,
                "BuildingIds":Building_IDs,
                "BuildingNames":Building_Names,
                "HolidayDate": New_Holiday_Date
            };
            this.props.SaveHoliday(editData);
            this.props.closeModalPopUp("close");
        }
        else{
            IsModalClose = true;
        }
    }

    render(getResponse,Response_of_BuildingsCall, getLabels, UserPreference_response) {
        let modal_form, modal_form_1, modal_form_2, Available_Buildings = null;
        //eslint-disable-next-line
        let Buildings_in_Select_input = null;
        let Buildingsdt = null;
        //var	CloseModal	=	this.props.CloseModal;
        let FilteredData = [],Data = [];

        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        let DtFormat = Conversions.UserPreferenceDateFormat(PreferedDateFormat);

        if (this.props.getResponse != undefined) {
                Buildings_in_Select_input = this.props.getResponse.BuildingsList.map(el => (
                     <option id={el.siteId}>{el.siteName}</option>
                ));
            }

            if (this.state.SelectedBuildings != undefined && this.state.SelectedBuildings != null) {
                if(this.state.SelectedBuildings.length > 0){
                    Buildingsdt = this.state.SelectedBuildings.map(el => (
                        <tr>
                            <td>{el.siteName}</td>
                            <td>{el.addrCity}</td>
                            <td>{el.addrStateProvince}</td>
                        </tr>
                    ));
                }
                else{
                    Buildingsdt = <tr> <td colSpan="4">No Records Found</td> </tr>
                }

            }

            // validations
            if(IsModalClose){
                 var errormsg =   <p  className="error_msg">
                 <img src={ErrorGif} alt="Trane Logo" />
                  {label['CheckTemperatureAdjustment.Text'] !== undefined ? label['CheckTemperatureAdjustment.Text'] : "Error: You left necessary fields blank or entered invalid values."}
                 </p>
               }
               if(this.state.buildingerror){
                var buildingerrormsg =   <p  className="error_msg">
                <img src={ErrorGif} alt="Trane Logo" />{label['SelectSubGroups.Error.Text'] !== undefined ? label['SelectSubGroups.Error.Text'] : "At least one checkbox must be checked!"} </p>
              }
            /* Form 1 modal Content, this form has new zone name and
               list of Building fields. */

                 modal_form_1 =    <div className="ChangeLimits_Modal">
                                     {errormsg}

                                    <h4 className="Modal_form_title">{label['ManageHolidays.CreateHoliday.Text'] !== undefined ? label['ManageHolidays.CreateHoliday.Text'] : "Create New Holiday"}</h4>
                                    <div className="Modal_form_group ">
                                        <label id="lbl_Holiday_AddHoliday_HolidayName" className="ChangeLimits_Modal_label">{label['ManageHolidays.Name.Text'] !== undefined ? label['ManageHolidays.Name.Text'] : "Name"}</label>
                                        <input id="txt_Holiday_AddHoliday_HolidayName" ref='New_Holiday_Name' className="ChangeLimits_Modal_input default-input" defaultValue={this.state.Holiday_Name} />
                                    </div>
                                    <div className="Modal_form_group ">
                                        <tr>
                                         <td> <label id="lbl_Holiday_AddHoliday_HolidayDate" className="ChangeLimits_Modal_label">{label['ManageHolidays.Date.Text'] !== undefined ? label['ManageHolidays.Date.Text'] : "Date"}</label></td>
                                         <td id="txt_Holiday_AddHoliday_HolidayDate" className="paddingleft"> <Flatpickr value={this.state.Holiday_Date} ref="New_Holiday_Date" onChange={this.handleChange} options={{minDate: "today", dateFormat: DtFormat}} className="flatpickr tenat_form_control mdl-textfield__input" /></td>
                                        </tr>
                                    </div>
                                    <div className="Modal_form_group ">
                                        <label id="lbl_Holiday_AddHoliday_HolidayBuilding" className="ChangeLimits_Modal_label">{label['ManageHolidays.Building.Text'] !== undefined ? label['ManageHolidays.Building.Text'] : "Buildings"}</label>

                                        <a id="link_Holiday_AddHoliday_SelectBuildings" onClick={this.nextForm} style={{color:'#6890C6'}}>{label['ManageHolidays.SelectBuilding.Text'] !== undefined ? label['ManageHolidays.SelectBuilding.Text'] : "Select Buildings.."}</a>

                                    </div>
                                    <div>
                                    <div className="table_container">
                                        <Table id="tbl_Holiday_AddHoliday_SelectBuildings" striped responsive className="Custom_table table_border">
                                            <tbody className="cell_container tenant_cell">
                                                <tr>
                                                    <th>{label['ManageHolidays.Column.Name.Text'] !== undefined ? label['ManageHolidays.Column.Name.Text'] : "Building Name"} </th>
                                                    <th>{label['ManageHolidays.Column.City.Text'] !== undefined ? label['ManageHolidays.Column.City.Text'] : "City"}</th>
                                                    <th>{label['ManageHolidays.Column.State.Text'] !== undefined ? label['ManageHolidays.Column.State.Text'] : "State"}</th>
                                                </tr>
                                                {Buildingsdt}
                                            </tbody>
                                        </Table>
                                    </div>
                                    </div>
                                    
                                    <FormGroup row >
                                        <Col sm={{ size: 12 }} style={{marginTop:'10px'}}>
                                            <Button id="btn_Holiday_AddHoliday_CancelSelectBuildings" className="btn-gray" onClick={this.CloseModal} >{label['CreateTenant.Cancel.Text'] !== undefined ? label['CreateTenant.Cancel.Text'] : "Cancel"}</Button>
                                            <Button id="btn_Holiday_AddHoliday_SaveSelectBuildings" className="btn-success" onClick={() => { this.HolidaySave(); } } >{label['CreateTenant.Save.Text'] !== undefined ? label['CreateTenant.Save.Text'] : "Save"}</Button>
                                        </Col>
                                    </FormGroup>
                                </div>


                if (this.props.Response_of_BuildingsCall != undefined) {

                    Data = this.props.Response_of_BuildingsCall.BuildingsDetailsList;

                    FilteredData = Data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                    if(FilteredData.length > 0){
                     Available_Buildings = FilteredData.map(el => (
                        <tr key={el.siteID}>
                        <td><input type="checkbox" id={el.siteID} ref={'ref_' + el.siteID} value={el.siteID} className="buildings_child_Check_box" /></td>
                        <td>{el.siteName} </td>
                        <td>{el.addrCity}</td>
                        <td>{el.addrStateProvince}</td>
                        </tr>
                    ));
                    } else{
                        Available_Buildings = <tr> <td colSpan="5">{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td> </tr>
                    }
                }
           // }


               modal_form_2 =     <div className="table_container">

               <SearchInput className="search-input" onChange={this.searchUpdated} />
               {buildingerrormsg}
               <h4 className="Modal_form_title">{label['ManageHolidays.BuildingHeader.Text'] !== undefined ? label['ManageHolidays.BuildingHeader.Text'] : "Select Building(s)"}</h4>
               <Table striped responsive className="Custom_table table_border">
                   <tbody className="cell_container tenant_cell">
                       <tr>
                           <th><input type="checkbox" className="buildings_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("buildings_child_Check_box","buildings_header_Check_box"); }} /></th>
                           <th>{label['ManageHolidays.Column.Name.Text'] !==  undefined ? label['ManageHolidays.Column.Name.Text'] : "Building Name"}</th>
                           <th>{label['ManageHolidays.Column.City.Text'] !== undefined ? label['ManageHolidays.Column.City.Text'] : "City"}</th>
                           <th>{label['ManageHolidays.Column.State.Text'] !== undefined ? label['ManageHolidays.Column.State.Text'] : "State"}</th>
                       </tr>
                      {Available_Buildings}
                   </tbody>
               </Table>
               <div>
               <FormGroup row >
                    <Col sm={{ size: 12 }} style={{marginTop:'10px'}}>
                        <Button id="btn_Holiday_CancelHoliday" className="btn-black btn-md ChangeLimits_Cancelbtn" onClick={this.closePopup} > {label['CreateTenant.Cancel.Text'] !== undefined ? label['CreateTenant.Cancel.Text'] : "Cancel"} </Button>
                        <Button id="btn_Holiday_SaveHoliday" className="btn-black btn-md ChangeLimits_Applybtn" onClick={() => { this.BuildingSave(Available_Buildings);} } >{label['CreateTenant.Save.Text'] !== undefined ? label['CreateTenant.Save.Text'] : "Save"} </Button>



                    </Col>
                </FormGroup>
               </div>
           </div>


            if(this.state.FormDisplay){
                    modal_form = modal_form_1
             }
             else{
                modal_form = modal_form_2
             }


        return (

            <div>
            {modal_form}

            </div>
        );
    }

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }
}


const mapStateToProps = state => {
    return {
        getResponse: state.buildingsRootReducer,
        Response_of_BuildingsCall: state.BuildingDetailsReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetBuildingsList: () => dispatch(GetBuildingsList()),
        GetBuildingsDetailsList: () => dispatch(GetBuildingsDetailsList()),
        SaveHoliday: (HolidayEditedData) => dispatch(SaveHoliday(HolidayEditedData)),
        closeModalPopUp: (data) => dispatch(closeModalPopUp(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddHolidayForm);




